import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class AircraftsEdit extends Component {

  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      registration: null,
      cost_center_crew: null,
      cost_center_manager: null,
      serial_number: null,
      ptbr_code: null,
      ca: null,
      iam: null,
      weight: null,
      ground_consumption: null,
      flight_consumption: null,
      fuel_capacity: null,
      cost_centers: [],
      cost_centers_select: [],
      aircraft_models_list: [],
      operation_types: [],
      cost_center_id: null,
      role_type: null,
      role_types_select: [
        {value: 'crew', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Tripulacao},
        {value: 'cvo', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.CVODVO},
        {value: 'master', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.MestreDeCarga},
        {value: 'mechanic', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Mecanico},
        {value: 'management', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Administrativo},
        {value: 'indirect', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Indireto},
      ],
      aircraft_model_id: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addCostCenter = this.addCostCenter.bind(this);
    this.deleteCostCenter = this.deleteCostCenter.bind(this);
    this.voeOmniUpdate = this.voeOmniUpdate.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/aeronave/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            registration: responseJson.data.main.registration,
            cost_center_crew: responseJson.data.main.cost_center_crew,
            cost_center_manager: responseJson.data.main.cost_center_manager,
            aircraft_model_id: responseJson.data.main.aircraft_model_id,
            serial_number: responseJson.data.main.serial_number,
            ptbr_code: responseJson.data.main.ptbr_code,
            ca: responseJson.data.main.ca_str,
            iam: responseJson.data.main.iam_str,
            weight: responseJson.data.main.weight_str,
            ground_consumption: responseJson.data.main.ground_consumption,
            flight_consumption: responseJson.data.main.flight_consumption,
            fuel_capacity: responseJson.data.main.fuel_capacity,
            cost_centers: responseJson.data.cost_centers,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        var url = config.get('api') + '/tipo/operacoes/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ operation_types: responseJson.data });
          }
        }).then(() => {
          var url = config.get('api') + '/centros-de-custo/lista';
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              self.setState({ cost_centers_select: responseJson.data });
            }
            }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); }); });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      registration: this.state.registration,
      cost_center_crew: this.state.cost_center_crew,
      cost_center_manager: this.state.cost_center_manager,
      aircraft_model_id: this.state.aircraft_model_id,
      serial_number: this.state.serial_number,
      ptbr_code: this.state.ptbr_code,
      ca: this.state.ca,
      iam: this.state.iam,
      weight: this.state.weight,
      ground_consumption: this.state.ground_consumption,
      flight_consumption: this.state.flight_consumption,
      fuel_capacity: this.state.fuel_capacity,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  addCostCenter(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      aircraft_id: this.state.id,
      cost_center_id: this.state.cost_center_id,
      role_type: this.state.role_type,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/centro/custo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ cost_centers: responseJson.data });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  deleteCostCenter(id) {
    if(window.confirm(this.locale.Aeronaves.EditarAeronaves.deletarCentroDeCusto)) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/centro/custo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'success') {
            self.setState({ cost_centers: responseJson.data });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Atualização de dados com o VoeOmni
  voeOmniUpdate(event) {
    event.preventDefault();
    if(window.confirm(this.locale.Aeronaves.EditarAeronaves.atualizarVoeOmni)) {
      this.handleAlert('', '', 'open');
      var id = this.state.id;
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/voeomni/' + id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if(responseJson.status === 'success') {
            self.setState({
              weight: responseJson.data.weight_str,
              ground_consumption: responseJson.data.ground_consumption,
              flight_consumption: responseJson.data.flight_consumption,
              fuel_capacity: responseJson.data.fuel_capacity,
            });
          }
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Aeronaves.EditarAeronaves.titulo}</h3>
      <div className="grid-buttons pull-right">
        <Link to="/aeronaves" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Modelo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.SelecioneModeloAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
                disabled
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Matricula}:</label>
              <input type="text" name="registration" className="form-control" placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.registration} onChange={this.handleChange.bind(this, 'registration')} disabled />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.NumeroSerie}:</label>
              <input type="text" name="serial_number" className="form-control" placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.serial_number} onChange={this.handleChange.bind(this, 'serial_number')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CA}:</label>
              <InputMask value={this.state.ca}  maskChar={null} name="ca" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'ca')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.IAM}:</label>
              <InputMask value={this.state.iam}  maskChar={null} name="iam" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'iam')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Peso}:</label>
              <input value={this.state.weight} name="weight" className="form-control" onChange={this.handleChange.bind(this, 'weight')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CodigoPTBR}:</label>
              <input value={this.state.ptbr_code} name="ptbr_code" className="form-control" onChange={this.handleChange.bind(this, 'ptbr_code')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.ConsumoHoraSolo}:</label>
              <input type="text" placeholder="" className="form-control" name="ground_consumption" value={this.state.ground_consumption} onChange={this.handleChange.bind(this, 'ground_consumption')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.ConsumoHoraVoo}:</label>
              <input type="text" placeholder="" className="form-control" name="flight_consumption" value={this.state.flight_consumption} onChange={this.handleChange.bind(this, 'flight_consumption')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CapacidadeDeCombustível}:</label>
              <input type="text" placeholder="" className="form-control" name="fuel_capacity" value={this.state.fuel_capacity} onChange={this.handleChange.bind(this, 'fuel_capacity')} />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Aeronaves.EditarAeronaves.formulario.botaoSalvarEdicao}</button>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftsEdit;



// WEBPACK FOOTER //
// ./src/Components/Aircrafts/AircraftsEdit.js